import { useQuery } from "@tanstack/react-query";
import { getfunctionConfig } from "shared/api/function_data";
import { queryKeys } from "shared/lib/queryClient";

function getFirstSidebarKey(sidebarOptions) {
  if (!sidebarOptions) return null;
  const firstSection = Object.values(sidebarOptions)[0];
  return firstSection?.items?.[0]?.key ?? null;
}

/**
 * Fetches function config whenever id, week, or year changes.
 * Backed by React Query so revisiting a week already viewed is served from cache
 * (deduped, no duplicate network calls). Admin saves invalidate this via
 * invalidateConfig().
 *
 * Return shape is unchanged: { config, loading, error, defaultSidebarKey }
 */
export function useFunctionConfig(functionId, week, year) {
  const { data: config, isLoading, error } = useQuery({
    queryKey: queryKeys.config(functionId, week, year),
    queryFn: () => getfunctionConfig(functionId, week, year),
    enabled: !!functionId,
  });

  const defaultSidebarKey = config
    ? config.sidebar_check || getFirstSidebarKey(config.function_sidebar)
    : null;

  return {
    config: config ?? null,
    loading: isLoading,
    error: error ? error.message : null,
    defaultSidebarKey,
  };
}
